import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "FOOTER bg-[#E9ECF0] border-t border-slate-300",
  style: {"box-shadow":"inset 0 1px 0 white"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "font-light py-3 px-5 text-gray-600 opacity-50 text-sm flex flex-row w-full" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("\n        An open source project by\n        "),
    /*#__PURE__*/_createElementVNode("a", { href: "https://github.com/calebjclark" }, "@calebjclark"),
    /*#__PURE__*/_createTextVNode(" and\n        "),
    /*#__PURE__*/_createElementVNode("a", { href: "https://github.com/blakebyrnes" }, "@blakebyrnes")
  ]),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("div", { class: "hidden md:block text-right flex-1" }, "\n        Because knowledge deserves to be free.\n      ")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, _hoisted_3))
}